import { Box } from "@mui/system";
import Typography from '@mui/material/Typography';
import { createElement } from "react";
import PropTypes from 'prop-types';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    createElement('div', {
      role: 'tabpanel',
      hidden: value !== index,
      id: `full-width-tabpanel-${index}`,
      'aria-labelledby': `full-width-tab-${index}`,
      ...other
    },
    value === index && (
      createElement(Box, { sx: { p: 3 } },
        createElement(Typography, null, children)
      )
    ))
  );
}
TabPanel.propTypes = {
  children: PropTypes.node,
  dir: PropTypes.string,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};
export default TabPanel;